import { hasReplied as hasRepliedAtom, replyCount } from '@/atoms/stats'
import { canWriteAtom } from '@/atoms/session'
import { HugeiconsIcon } from '@hugeicons/react'
import { Comment } from '@hugeicons/core-free-icons'
import { Event } from '@nostr/tools/wasm'
import { useAtomValue } from 'jotai'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PostEditor from '../PostEditor'
import { formatCount } from './utils'

export default function ReplyButton({ event }: { event: Event }) {
  const { t } = useTranslation()
  const count = useAtomValue(replyCount(event.id))
  const hasReplied = useAtomValue(hasRepliedAtom(event.id))

  const [open, setOpen] = useState(false)
  const canWrite = useAtomValue(canWriteAtom)

  return (
    <>
      <button
        className="flex gap-1 items-center enabled:hover:text-blue-400 disabled:opacity-50 disabled:cursor-not-allowed pr-3 h-full text-muted-foreground"
        onClick={(e) => {
          e.stopPropagation()
          setOpen(true)
        }}
        disabled={!canWrite}
        title={t('Reply')}
      >
        <HugeiconsIcon icon={Comment} className={`${hasReplied ? 'text-primary' : ''}`} />
        {!!count && (
          <div className={`text-sm ${hasReplied ? 'text-primary' : ''}`}>{formatCount(count)}</div>
        )}
      </button>
      <PostEditor parentEvents={[event]} open={open} setOpen={setOpen} />
    </>
  )
}
